import { useEffect, useState } from "react";
import { BellRinging, ArrowClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";
import client from "../../lib/api";

export default function CheckoutNudgeCard() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => client.get("/admin/marketing/checkout-nudges?days=7").then((r) => setSt(r.data)).catch(() => setSt({ sent: 0, converted: 0, eligible_now: 0 }));
  useEffect(() => { load(); }, []);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await client.post("/admin/marketing/checkout-nudges/run");
      toast.success(data.users ? `Nudged ${data.users} account${data.users === 1 ? "" : "s"} — ${data.email} email, ${data.sms} text` : "Nobody is waiting on a card right now");
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Couldn't run"); }
    finally { setBusy(false); }
  };
  if (!st) return null;
  return (
    <div className="card-surface p-5" data-testid="checkout-nudge-card">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-neutral-500"><BellRinging size={13} /> Abandoned checkout nudges · last 7 days</div>
        <button type="button" onClick={run} disabled={busy} className="btn-primary rounded-full px-3 py-1.5 text-xs inline-flex items-center gap-1.5 disabled:opacity-50" data-testid="checkout-nudge-run">
          <ArrowClockwise size={13} className={busy ? "animate-spin" : ""} /> Run now
        </button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {[["Waiting on a card", st.eligible_now, "checkout-nudge-eligible"], ["Nudges sent", st.sent, "checkout-nudge-sent"], ["Added a card after", st.converted, "checkout-nudge-converted"]].map(([l, v, id]) => (
          <div key={l} className="rounded-lg bg-white/[0.03] border border-white/[0.06] p-3" data-testid={id}>
            <div className="text-[10px] uppercase tracking-widest text-neutral-500">{l}</div>
            <div className="text-xl font-semibold text-white mt-1">{v ?? 0}</div>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-neutral-500 mt-3">Runs every hour on its own: anyone who signed up {st.after_hours || 1}h+ ago without adding a card gets one email (and one text if they left a phone, 7am–9pm their time) with a one-tap link to checkout. Never repeats.</p>
    </div>
  );
}
